import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: grid;
  grid-template-areas:
    "icon description "
    ". industry-list ";
  grid-template-columns: auto 1fr;
  gap: 20px;

  margin-block: 24px 40px;
  padding-block: 24px;

  border-block-end: 1px solid #000000;

  border-block-start: 1px solid #000000;
`;

export const DescriptionContainer = styled.div`
  grid-area: description;

  gap: 20px;

  max-inline-size: 800px;

  color: #000000;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 140%;
`;

export const IconContainer = styled.div`
  grid-area: icon;
  grid-row: 1 / -1;

  align-self: start;
`;

export const BoldText = styled.span`
  font-weight: 700;
`;
